/**
 * Licensed Materials - Property of IBM
 * 5737-M66, 5900-AAA, 5900-A0N, 5725-S86, 5737-I75
 * © Copyright IBM Corp. 2020, 2023 All Rights Reserved.
 * US Government Users Restricted Rights - Use, duplication, or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { saveAs } from 'file-saver';

const propTypes = {
  children: PropTypes.node.isRequired,
  blob: PropTypes.any.isRequired, // eslint-disable-line react/forbid-prop-types
  fileName: PropTypes.string.isRequired,
};

class DownloadFileLink extends Component {
  handleClick = () => {
    const { blob, fileName } = this.props;
    saveAs(blob, fileName);
  };

  render() {
    const { children } = this.props;

    return React.Children.map(children, eachChild =>
      React.cloneElement(eachChild, { onClick: this.handleClick })
    );
  }
}

DownloadFileLink.propTypes = propTypes;
export default DownloadFileLink;
